import React from 'react';
import { Navigate } from 'react-router-dom';
import Login from '../components/Login';
import Home from '../components/Home';
import Dashboard from '../components/Dashboard';
import NovelEditor from '../components/NovelEditor';
import AdminPanel from '../components/AdminPanel';
import ProtectedRoute from '../components/ProtectedRoute';
import Recharge from '../components/Recharge';
import Feedback from '../components/Feedback';
import AutoNovelPage from '../components/AutoNovelPage';
import ToolsPage from '../components/ToolsPage';
import Workspace from '../components/Workspace';
import ProjectsPage from '../components/ProjectsPage';

const routes = [
  {
    path: '/',
    element: <Home />
  },
  {
    path: '/login',
    element: <Login />
  },
  {
    path: '/register',
    element: <Login mode="register" />
  },
  {
    path: '/dashboard',
    element: <ProtectedRoute><Dashboard /></ProtectedRoute>
  },
  {
    path: '/auto-novel',
    element: <ProtectedRoute><AutoNovelPage /></ProtectedRoute>
  },
  {
    path: '/tools',
    element: <ProtectedRoute><ToolsPage /></ProtectedRoute>
  },
  {
    path: '/tools/:toolId',
    element: <ProtectedRoute><Navigate to="/tools" replace /></ProtectedRoute>
  },
  {
    path: '/workspace',
    element: <ProtectedRoute><Workspace /></ProtectedRoute>
  },
  {
    path: '/workspace/:novelId',
    element: <ProtectedRoute><Workspace /></ProtectedRoute>
  },
  {
    path: '/prompt',
    element: <ProtectedRoute><Navigate to="/tools" replace /></ProtectedRoute>
  },
  {
    path: '/projects',
    element: <ProtectedRoute><ProjectsPage /></ProtectedRoute>
  },
  {
    path: '/history',
    element: <ProtectedRoute><Navigate to="/tools" replace /></ProtectedRoute>
  },
  {
    path: '/favorites',
    element: <ProtectedRoute><Navigate to="/tools" replace /></ProtectedRoute>
  },
  {
    path: '/novel-editor/:novelId',
    element: <ProtectedRoute><NovelEditor /></ProtectedRoute>
  },
  {
    path: '/novel/:novelId',
    element: <Navigate to={location => `/novel-editor/${location.pathname.split('/').pop()}`} replace />
  },
  {
    path: '/kOjtx3AXNmCsT5Wz',
    element: <ProtectedRoute><AdminPanel /></ProtectedRoute>
  },
  {
    path: '/recharge',
    element: <ProtectedRoute><Recharge /></ProtectedRoute>
  },
  {
    path: '/feedback',
    element: <ProtectedRoute><Feedback /></ProtectedRoute>
  }
];

export default routes; 